import { createCompoundComponent } from '../../utilities'
import { ContentTeaser as BaseContentTeaser } from './ContentTeaser'
import { Image } from './components/Image'
import { Content } from './components/Content'
import { Timestamp } from './components/Timestamp'
import { Title } from './components/Title'
import { Excerpt, ExcerptText } from './components/Excerpt'
import { Link } from './components/Link'

export type { ContentTeaserProps } from './types'

export const ContentTeaser = createCompoundComponent(BaseContentTeaser, {
  Content,
  Excerpt,
  ExcerptText,
  Image,
  Link,
  Timestamp,
  Title,
})
